import isFalsy from 'utils/predicates/isFalsy.util';

const isEmptyArray = (value) => Array.isArray(value) && isFalsy(value.length);

// noinspection JSUnusedGlobalSymbols
export default isEmptyArray;
